import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';

// Set absolute location path
const ORIGIN = window.location.origin;
let LOCATION = '//kamerad-film.test';
if (ORIGIN.indexOf('localhost') === -1) LOCATION = ORIGIN + '/cms';
export const ABSPATH = LOCATION;


Vue.use(Vuex);
const store = new Vuex.Store({
		debug: true,
		state: {
			title: 'Kamerad Film',
			loadedSetup: false,
			loadedPage: false,
			loadedOverlay: false,
			//
			vimeo: [],
			menu: {},
			menufooter: {},
			header: {},
			content: {},
			overlayer: {}
		},
		mutations: {
			insertSetup(state, value){
				state.loadedSetup = true;
				Vue.set(state, 'title', value.title);
				Vue.set(state, 'menu', value.menu);
				Vue.set(state, 'menufooter', value.menufooter);
			},
			insertPage(state, value){
				state.loadedPage = true;
				Vue.set(state, 'header', value.header);
				Vue.set(state, 'content', value.content);

				document.title = value.header.name;
			},
			fetchVimeo(state, value){
				// if (state.vimeo.length >= value.length ) return
				let thumbs = [];
				console.log("state vimeo >", state.vimeo.length, value.length);
				_.each(value, (mov,k) => {
					fetch(`http://vimeo.com/api/v2/video/${mov.id}.json`)
						.then( response => response.json() )
						.then( movData => {
							thumbs.push(movData[0]);
						})
						.catch(() => {
							console.log('Error: JSON not found!');
						});
				})
				Vue.set(state, 'vimeo', thumbs);
			},
			resultContent(state){
				console.log('resultContent');
				return state.content;
			},
			setOverlayerDom (state, value) {
				state.overlayer = value;
			}
		}

	});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js